import api from '../';

class MemoryXGameApi {
    static getGroups(locale) {
        return api.axios.get('/memory-x/groups', { params: { locale } }).then(response => response.data);
    }

    static getItemsByRequest(params) {
        return api.axios.get('/memory-x/items', { params }).then(response => response.data.items);
    }
}

export default MemoryXGameApi;
